import API from 'utils/api';
import { message } from 'antd';
import getFormattedValues from 'utils/formatValues';
import { onError } from 'utils/handlers';

export const baseURI = 'recaudacion/historiales-de-citas/';

/**
 * GET Citas
 * param {object} params
 * @returns {Promise<object>}
 */
export const getHistorialDeCitas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Historial De Cita
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistorialDeCita = async (_values) => {
  try {
    const values = getFormattedValues(_values);
    const response = await API.post(baseURI, values);
    message.info(response.detail || 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Historial De Cita
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistorialDeCita = async (id, _values) => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const response = await API.patch(`${baseURI}${id}`, values);
    message.info(response.detail || 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Historial De Cita
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteHistorialDeCita = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    message.info(response.detail || 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
